import api from '../config/api';

const planillaSeguroService = {
  async obtenerSeguros(planillaId) {
    const response = await api.get(`/planillas/${planillaId}/seguros`);
    return response.data;
  },

  async guardarSeguro(planillaId, codigoPlame, montos) {
    const response = await api.put(`/planillas/${planillaId}/seguros`, {
      codigo_plame: codigoPlame,
      montos,
    });
    return response.data;
  },

  async eliminarSeguro(planillaId, codigoPlame) {
    const response = await api.delete(`/planillas/${planillaId}/seguros/${codigoPlame}`);
    return response.data;
  },
};

export default planillaSeguroService;
